import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-98ZT7FLQEB";

const GoogleAnalyticsTag = () => {
    const location = useLocation();
    const initialisedRef = useRef(false);
    const lastPathRef = useRef("");

    useEffect(() => {
        if (!initialisedRef.current) {
            ReactGA.initialize(MEASUREMENT_ID);
            initialisedRef.current = true;
        }

        const path = location.pathname + (location.search || "");
        if (lastPathRef.current !== path) {
            ReactGA.send({ hitType: "pageview", page: path, title: document.title });
            lastPathRef.current = path;
        }
    }, [location]);

    return null;
};

export default GoogleAnalyticsTag;